import { all } from "redux-saga/effects";
import { ProfileSagas } from "../admin/profileSaga";
import { AdmissionSagas } from '../admissions/admissionsSaga';
import { AttenderSagas } from "../Attender/attenderSaga";
import { AuthSaga } from "../auth/authSaga";
import { BlockSagas } from '../block/blockSaga';
import { dashboardSagas } from "../dashboard/dashboardSaga";
import { departmentSagas } from '../department/departmentSage';
import { DoctorSagas } from "../doctor/doctorSaga";
import { floorSagas } from '../floor/floorSaga';
import { PatientSagas } from "../patient/patientSaga";
import { RoleSagas } from "../role/roleSaga";
import { securityOfficerSagas } from '../secuityOfficer/securitySaga';
import { specialistSagas } from '../specialist/specialistSaga';
import { StaffSagas } from "../staff/StaffSaga";
import { TransferPatientSagas } from '../TransferPatient/transferPatientSaga';
import { wardSagas } from '../ward/wardSaga';

export default function* rootSaga() {
  yield all([
    AuthSaga(),
    PatientSagas(),
    securityOfficerSagas(),
    BlockSagas(),
    floorSagas(),  
    wardSagas(),
    departmentSagas(),
    specialistSagas(),
    DoctorSagas(),
    StaffSagas(),
    RoleSagas(),
    TransferPatientSagas(),
    AttenderSagas(),
    AdmissionSagas(),
    dashboardSagas(),
    ProfileSagas()
  ]);
}
